module.exports = __webpack_public_path__ + "img/yl3091.19d4b158.png";